import type { ComponentType } from "react";
import { Button, type ButtonProps } from "../Button/Button";
import { useHoldToRepeat } from "./useHoldToRepeat";
import * as styles from "./CarouselAction.module.scss";

type ActionProps = ButtonProps & {
  Icon: ComponentType<{ className?: string }>;
  onAction: () => void;
  canAction: boolean;
};

export const Action = ({
  Icon,
  onAction,
  canAction,
  children,
  disabled,
  ...props
}: ActionProps) => {
  const holdToRepeat = useHoldToRepeat(onAction);

  return (
    <Button
      type="button"
      size="sm"
      variant="outlined"
      {...props}
      {...holdToRepeat}
      disabled={disabled ?? !canAction}
    >
      {children ?? <Icon className={styles.icon} />}
    </Button>
  );
};
